import { Component } from '@angular/core';

@Component({
    selector: 'dk-currency-calculator-page',
    template: require('./currency-calculator-page.html')
})

export class CurrencyCalculatorPageComponent {

}
